import React from 'react';
import { useLocation } from 'react-router';

const Success = () => {
    const location = useLocation()

    return (
        <div>
            success
        </div>
    );
};

export default Success;